import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LiveSubscriptionType } from "../../app/Subscriptions/types/LiveSubscriptionTypes.ts";
import { DocumentReference} from "firebase/firestore";
import { AdditionalQuestionType } from "../../app/Subscriptions/Pages/Offers&Events/Components/EventDetailPage";
import { CustomerKYCFieldType } from "../../app/Common/Modals/CustomerKYCModal";


type ForBankModal = {
    accountNumber: string;
    IFSCCode: string;
    accountName: string;
}

type ForEditSubscriptionModal = {
    products: { name: string; price: string; }[];
    id: string,
    Name: string,
    Price: string,
    paymentProfileID: number,
    showMeInList: boolean,

}

type ForQuickAddModal = {
    id: string,
    subscriptionName: string,
    type: string,
    advance: number,
    Price: number,
    align2monthlyBoundary: boolean
}


type ForPauseLiveSubscriptionModal = {
    subscriptionId: string;
    LiveSubscriptionId: string;
}

type ForMultiMonthPauseModal = {   
    LiveSubscriptionId: string;
    align2monthlyBoundary: boolean;
}

type ForMultiMonthResumeModal = {
    LiveSubscriptionId: string;
    align2monthlyBoundary: boolean;
}

type ForMarkOrderPaidModal = {
    orderId: string,
    subscriptionId:string
}

type ForEditLiveSubscriptionModal = {
    LiveSubscriptionId: string,
    SubscriptionPrice: number,
    NoGSTBatch: boolean
}

type ForTerminateLiveSubscriptionModal = {
    SubscriptionId: string;
    LiveSubscriptionId: string;
}

type ForDeleteLiveSubscriptionModal = {
    SubscriptionId: string;
    LiveSubscriptionId: string;
}


type ForOrderSummaryModal = {
    orderId: string
}

type ForStatsForOrders = {
    subscriptionId: string,
    subscriptionName: string,
    cycleName: string
}

type ForRemindPaymentWhatsappModal = {
    consumerName: string,
    chargeable: string,
    subscriptionName: string,
    cycleName: string,
    studentName: string,
    payment_link: string,
    providerName: string,
    consumerPhone: string,
    serviceProviderID: string,
    orderId: string,
    secondaryMobile: string,
    bQuickCollect: boolean,
    quickCollectString: string,
    invoiceString: string,
    email: string,
    secondaryEmail: string
}


type ForFetchExistingSubscribersModal = {
    data: LiveSubscriptionType[]
}

type ForPauseErrorModal = {
    subscriptionId: string,
    LiveSubscriptionId: string,
    orderMonth: string
}

type ForResumeLiveSubscriptionModal = {
    LiveSubscriptionId: string,
    SubscriptionId: string,
    chargeNowVisible: boolean
}

type ForAddTeamMemberModal = {
    name: string;
    number: string;
    role: "Administrator" | "Manager" | "Observer";
    selectedSubscriptions: DocumentReference[];
    userPhoto: string;
    actionType: 'grantRole' | 'revokeRole';
    oldRole?: {
        name: string;
        number: string;
        role: string;
        businessName: string;
        serviceProviderReference: DocumentReference;
        assignedSubscriptions: DocumentReference[];
        assignmentStatus: string;
        userPhoto: string;
    };
}

interface RevokeRoleModalData {
    id: string;
    name: string;
    number: string;
    role: string;
    isAccepted: boolean;
    businessName: string;
    actionType: 'grantRole' | 'revokeRole';
}

// Removed unused interface


type ForEditOfferModal = {
    offerId: string;
}

type ForEditEventsModal = {
    eventId: string;
}

type ForEventQRCode = {
    eName: string;
    eStartTime: { seconds: number; nanoseconds: number };
    address: string;
    eventLink: string;
}

type ForOfferQRCode = {
    BuzzName: string;
    StartDate: { seconds: number; nanoseconds: number };
    EndDate: { seconds: number; nanoseconds: number };
    address: string;
    offerLink: string;
}

type ForQRCodeSource = {
    qrCodeSource: string;

}
  
type ForCancelPauseModal = {
    LiveSubscriptionId: string;
    align2monthlyBoundary: boolean;
}


type ForMMEditOrderModal = {
    orderId: string;
    subscriptionId: string;
}

type ForAddEventCustomFieldsModal = {
    eventId: string;
}

type ForEditEventCustomFieldModal = {
    question: AdditionalQuestionType;
    eventId: string;    
}

type ForDeleteEventCustomFieldModal = {
    questionId: string;
    eventId: string;
}

type ForSingleRaiseInvoiceModal = {
    subscriptionId: string;
    liveSubId: string;
}

type ForQuickCollectModal = {
    subscriptionId: string;
    liveSubId: string;
}

type ForEditorJSModal = {
    content: any; // EditorJS content object
    fieldType: 'description' | 'terms'; // Which field is being edited
    sourceModal: string; // Which modal opened the editor
}

type ForAddCustomerKYCFieldModal = {
    // Empty for now, can be extended if needed
}

type ForEditCustomerKYCFieldModal = {
    question: CustomerKYCFieldType;    
}

type ForDeleteCustomerKYCFieldModal = {
    questionId: number;
}

type ForMoveStudentModal = {
    LiveSubscriptionId: string;
    currentSubscriptionType: string;
}

type ArbitrarySlice = {
    ForBankModal: ForBankModal,

    ForEditSubscriptionModal: ForEditSubscriptionModal,
    ForQuickAddModal: ForQuickAddModal,
    ForPauseLiveSubscriptionModal: ForPauseLiveSubscriptionModal,
    ForMarkOrderPaidModal: ForMarkOrderPaidModal,
    ForEditLiveSubscriptionModal: ForEditLiveSubscriptionModal,
    ForTerminateLiveSubscriptionModal: ForTerminateLiveSubscriptionModal,
    ForOrderSummaryModal: ForOrderSummaryModal,
    ForRemindPaymentWhatsappModal: ForRemindPaymentWhatsappModal,
    ForStatsForOrders: ForStatsForOrders,
    ForFetchExistingSubscribersModal: ForFetchExistingSubscribersModal,
    ForDeleteLiveSubscriptionModal:ForDeleteLiveSubscriptionModal,
    ForPauseErrorModal:ForPauseErrorModal,
    ForResumeLiveSubscriptionModal:ForResumeLiveSubscriptionModal,
    ForAddTeamMemberModal:ForAddTeamMemberModal,
    ForRevokeRoleModal: RevokeRoleModalData | null,
    ForEditEventsModal:ForEditEventsModal,
    ForEditOfferModal:ForEditOfferModal,
    ForEventQRCode:ForEventQRCode,
    ForOfferQRCode:ForOfferQRCode,
    ForQRCodeSource:ForQRCodeSource,
    ForMultiMonthPauseModal: ForMultiMonthPauseModal,
    ForMultiMonthResumeModal: ForMultiMonthResumeModal,
    ForCancelPauseModal: ForCancelPauseModal,
    ForMMEditOrderModal: ForMMEditOrderModal,
    ForAddEventCustomFieldsModal: ForAddEventCustomFieldsModal,
    ForEditEventCustomFieldModal: ForEditEventCustomFieldModal,
    ForDeleteEventCustomFieldModal: ForDeleteEventCustomFieldModal,
    ForSingleRaiseInvoiceModal: ForSingleRaiseInvoiceModal,
    ForQuickCollectModal: ForQuickCollectModal,
    ForEditorJSModal: ForEditorJSModal,
    ForAddCustomerKYCFieldModal: ForAddCustomerKYCFieldModal,
    ForEditCustomerKYCFieldModal: ForEditCustomerKYCFieldModal,
    ForDeleteCustomerKYCFieldModal: ForDeleteCustomerKYCFieldModal,
    ForMoveStudentModal: ForMoveStudentModal

}


const initialState: ArbitrarySlice = {
    ForBankModal: {
        accountNumber: "",
        IFSCCode: "",
        accountName: ""
    },
    ForEditSubscriptionModal: {
        id: "",
        Name: "",
        Price: "",
        paymentProfileID: 0,
        showMeInList: true,
        products: []
    },
    ForQuickAddModal: {
        id: "",
        subscriptionName: "",
        type: "",
        advance: 0,
        Price: 0,
        align2monthlyBoundary: false

    },
    ForPauseLiveSubscriptionModal: {
        subscriptionId: "",
        LiveSubscriptionId: ""
    },
    ForMarkOrderPaidModal: {
        orderId: "",
        subscriptionId: ""
    },
    ForEditLiveSubscriptionModal: {
        LiveSubscriptionId: "",
        SubscriptionPrice: 0,
        NoGSTBatch: false

    },
    ForTerminateLiveSubscriptionModal: {
        LiveSubscriptionId: "",
        SubscriptionId: ""
    },
    ForOrderSummaryModal: {
        orderId: ""
    },
    ForRemindPaymentWhatsappModal: {
        consumerName: "",
        chargeable: "",
        subscriptionName: "",
        cycleName: "",
        studentName: "",
        payment_link: "",
        providerName: "",
        consumerPhone: "",
        serviceProviderID: "",
        orderId: "",
        secondaryMobile: "",
        bQuickCollect: false,
        quickCollectString: "",
        invoiceString: "",
        email: "",
        secondaryEmail: ""
    },
    ForStatsForOrders: {
        subscriptionId: "",
        subscriptionName: "",
        cycleName: ""
    },
    ForFetchExistingSubscribersModal: {
        data: []
    },
    ForDeleteLiveSubscriptionModal: {
        SubscriptionId: "",
        LiveSubscriptionId: ""
    },
    ForPauseErrorModal: {
        subscriptionId: "",
        LiveSubscriptionId: "",
        orderMonth: ""
    },
    ForResumeLiveSubscriptionModal: {
        LiveSubscriptionId: "",
        SubscriptionId: "",
        chargeNowVisible: false
    },
    ForAddTeamMemberModal: {
        name: "",
        number: "",
        role: "Administrator",
        selectedSubscriptions: [],
        userPhoto: "",
        actionType: 'grantRole'
    },
    ForRevokeRoleModal: null,
    ForEditEventsModal: {
        eventId: ""
    },
    ForEditOfferModal: {
        offerId: ""
    },
    ForEventQRCode:{
        eName: "",
        eStartTime: { seconds: Math.floor(Date.now() / 1000), nanoseconds: 0 },
        address: "",
        eventLink: ""
    },
    ForOfferQRCode:{
        BuzzName: "",
        StartDate: { seconds: Math.floor(Date.now() / 1000), nanoseconds: 0 },
        EndDate: { seconds: Math.floor(Date.now() / 1000), nanoseconds: 0 },
        address: "",
        offerLink: ""
    },
    ForQRCodeSource:{
      qrCodeSource: "" 
    },
    ForMultiMonthPauseModal: {
        LiveSubscriptionId: "",
        align2monthlyBoundary: false
    },
    ForMultiMonthResumeModal: {
        LiveSubscriptionId: "",
        align2monthlyBoundary: false
    },

    ForCancelPauseModal: {
        LiveSubscriptionId: "",
        align2monthlyBoundary: false
    },
    ForMMEditOrderModal: {
        orderId: "",
        subscriptionId: ""
    },
    ForAddEventCustomFieldsModal: {
        eventId: ""
    },
    ForEditEventCustomFieldModal: {
        question: {
            id: 0,
            type: "",
            fieldDescription: "",
            options: [],
            isRequired: false
        },
        eventId: ""
    },
    ForDeleteEventCustomFieldModal: {
        questionId: "",
        eventId: ""
    },
    ForSingleRaiseInvoiceModal: {
        subscriptionId: "",
        liveSubId: ""
    },
    ForQuickCollectModal: {
        subscriptionId: "",
        liveSubId: ""
    },
    ForEditorJSModal: {
        content: null,
        fieldType: 'description',
        sourceModal: ''
    },
    ForAddCustomerKYCFieldModal: {
        // Empty for now
    },
    ForEditCustomerKYCFieldModal: {
        question: {
            id: 0,
            type: "",
            fieldDescription: "",
            options: [],
            isRequired: false
        }
    },
    ForDeleteCustomerKYCFieldModal: {
        questionId: 0
    },
    ForMoveStudentModal: {
        LiveSubscriptionId: "",
        currentSubscriptionType: ""
    }
}


// eslint-disable-next-line react-refresh/only-export-components
const ArbitrarySlice = createSlice({
    name: "ArbitrarySlice",
    initialState,
    reducers: {
        setBankAccountNumber: (state, action) => {
            state.ForBankModal.accountNumber = action.payload;
        },
        setIFSCCode: (state, action) => {
            state.ForBankModal.IFSCCode = action.payload;
        },
        setAccountName: (state, action) => {
            state.ForBankModal.accountName = action.payload;
        },
        setFieldsForEditSubscriptionModal: (state, action) => {
            state.ForEditSubscriptionModal.Name = action.payload.Name;
            state.ForEditSubscriptionModal.Price = action.payload.Price;
            state.ForEditSubscriptionModal.paymentProfileID = action.payload.paymentProfileID;
            state.ForEditSubscriptionModal.showMeInList = action.payload.showMeInList;
            state.ForEditSubscriptionModal.id = action.payload.id;
        },
        // Quick Add
        setFieldsForQuickAddModal: (state, action) => {
            state.ForQuickAddModal.id = action.payload.id;
            state.ForQuickAddModal.subscriptionName = action.payload.subscriptionName;
            state.ForQuickAddModal.type = action.payload.type;
            state.ForQuickAddModal.advance = action.payload.advance;
            state.ForQuickAddModal.Price = action.payload.Price,
            state.ForQuickAddModal.align2monthlyBoundary = action.payload.align2monthlyBoundary

        },
        //     PauseSub
        setFieldsForPauseLiveSubscriptionModal: (state, action) => {
            state.ForPauseLiveSubscriptionModal.LiveSubscriptionId = action.payload.LiveSubscriptionId;
            state.ForPauseLiveSubscriptionModal.subscriptionId = action.payload.subscriptionId;
        },
        setFieldsForMarkOrderPaidModal: (state, action) => {
            state.ForMarkOrderPaidModal.orderId = action.payload.orderId;
            state.ForMarkOrderPaidModal.subscriptionId = action.payload.subscriptionId;
        },
        setFieldsForEditLiveSubscriptionModal: (state, action) => {
            state.ForEditLiveSubscriptionModal.LiveSubscriptionId = action.payload.LiveSubscriptionId;
            state.ForEditLiveSubscriptionModal.SubscriptionPrice = action.payload.SubscriptionPrice;
            state.ForEditLiveSubscriptionModal.NoGSTBatch = action.payload.NoGSTBatch;
        },
        setFieldsForTerminateLiveSubscriptionModal: (state, action) => {
            state.ForTerminateLiveSubscriptionModal.LiveSubscriptionId = action.payload.LiveSubscriptionId;
            state.ForTerminateLiveSubscriptionModal.SubscriptionId = action.payload.SubscriptionId;
        },
        setFieldsForOrderSummaryModal: (state, action) => {
            state.ForOrderSummaryModal.orderId = action.payload.orderId
        },

        setFieldsForStatsForOrders: (state, action) => {
            state.ForStatsForOrders.subscriptionId = action.payload.subscriptionId;
            state.ForStatsForOrders.subscriptionName = action.payload.subscriptionName;
            state.ForStatsForOrders.cycleName = action.payload.cycleName;
        },
        setFieldsForRemindPaymentWhatsappModal: (state, action) => {
            state.ForRemindPaymentWhatsappModal.consumerName = action.payload.consumerName;
            state.ForRemindPaymentWhatsappModal.chargeable = action.payload.chargeable;
            state.ForRemindPaymentWhatsappModal.subscriptionName = action.payload.subscriptionName;
            state.ForRemindPaymentWhatsappModal.cycleName = action.payload.cycleName;
            state.ForRemindPaymentWhatsappModal.studentName = action.payload.studentName;
            state.ForRemindPaymentWhatsappModal.payment_link = action.payload.payment_link;
            state.ForRemindPaymentWhatsappModal.providerName = action.payload.providerName;
            state.ForRemindPaymentWhatsappModal.consumerPhone = action.payload.consumerPhone;
            state.ForRemindPaymentWhatsappModal.serviceProviderID = action.payload.serviceProviderID;
            state.ForRemindPaymentWhatsappModal.orderId = action.payload.orderId;
            state.ForRemindPaymentWhatsappModal.secondaryMobile = action.payload.secondaryMobile;
            state.ForRemindPaymentWhatsappModal.bQuickCollect = action.payload.bQuickCollect;
            state.ForRemindPaymentWhatsappModal.quickCollectString = action.payload.quickCollectString;
            state.ForRemindPaymentWhatsappModal.invoiceString = action.payload.invoiceString;
            state.ForRemindPaymentWhatsappModal.email = action.payload.email;
            state.ForRemindPaymentWhatsappModal.secondaryEmail = action.payload.secondaryEmail;
        },
        updateDataForFetchExistingSubsctibersModal: (state, action) => {
            state.ForFetchExistingSubscribersModal.data.push(action.payload);
        },
        setDataForFetchExistingSubsctibersModal: (state, action) => {
            state.ForFetchExistingSubscribersModal.data = action.payload;
        },
        setFieldsForDeleteLiveSubscriptionModal: (state, action) => {
            state.ForDeleteLiveSubscriptionModal.LiveSubscriptionId = action.payload.LiveSubscriptionId;
            state.ForDeleteLiveSubscriptionModal.SubscriptionId = action.payload.SubscriptionId;
        },
        setFieldsForPauseErrorModal: (state, action) => {
            state.ForPauseErrorModal.LiveSubscriptionId = action.payload.LiveSubscriptionId;
            state.ForPauseErrorModal.subscriptionId = action.payload.SubscriptionId;
            state.ForPauseErrorModal.orderMonth = action.payload.orderMonth;
        },
        setFieldsForResumeLiveSubscriptionModal: (state, action) => {
            state.ForResumeLiveSubscriptionModal.LiveSubscriptionId = action.payload.LiveSubscriptionId;
            state.ForResumeLiveSubscriptionModal.SubscriptionId = action.payload.SubscriptionId;
            state.ForResumeLiveSubscriptionModal.chargeNowVisible = action.payload.chargeNowVisible;
        },
        setFieldsForAddTeamMemberModal: (state, action) => {
            state.ForAddTeamMemberModal.name = action.payload.name;
            state.ForAddTeamMemberModal.number = action.payload.number;
            state.ForAddTeamMemberModal.role = action.payload.role;
            state.ForAddTeamMemberModal.selectedSubscriptions = action.payload.selectedSubscriptions;

            state.ForAddTeamMemberModal.userPhoto = action.payload.userPhoto;
            state.ForAddTeamMemberModal.actionType = action.payload.actionType;
        },
        setFieldsForRevokeRoleModal: (state, action: PayloadAction<RevokeRoleModalData>) => {
            state.ForRevokeRoleModal = {
                id: action.payload.id || "",
                name: action.payload.name || "",
                number: action.payload.number || "",
                role: action.payload.role || "",
                isAccepted: action.payload.isAccepted,
                businessName: action.payload.businessName || "",
                actionType: action.payload.actionType || "grantRole"
            };
        },
        setFieldsForEditEventsModal: (state, action) => {
            state.ForEditEventsModal.eventId = action.payload.eventId;
        },
        setFieldsForEditOfferModal: (state, action) => {
            state.ForEditOfferModal.offerId = action.payload.offerId;
        },

        setFieldsForEventQRCode:(state, action) =>{
            state.ForEventQRCode.eName = action.payload.eName;
            state.ForEventQRCode.eStartTime = action.payload.eStartTime;
            state.ForEventQRCode.eventLink = action.payload.eventLink;
            state.ForEventQRCode.address = action.payload.address;
        },
        setFieldsForOfferQRCode:(state, action) =>{
            state.ForOfferQRCode.BuzzName = action.payload.BuzzName;
            state.ForOfferQRCode.StartDate = action.payload.StartDate;
            state.ForOfferQRCode.EndDate = action.payload.EndDate;
            state.ForOfferQRCode.offerLink = action.payload.offerLink;
            state.ForOfferQRCode.address = action.payload.address;
        },
        setFieldsForQRCodeSource:(state, action) => {
            state.ForQRCodeSource.qrCodeSource = action.payload.qrCodeSource;
        },
        setFieldsForMultiMonthPauseModal: (state, action) => {
            state.ForMultiMonthPauseModal.LiveSubscriptionId = action.payload.LiveSubscriptionId;
            state.ForMultiMonthPauseModal.align2monthlyBoundary = action.payload.align2monthlyBoundary;
        },
        setFieldsForMultiMonthResumeModal: (state, action) => {
            state.ForMultiMonthResumeModal.LiveSubscriptionId = action.payload.LiveSubscriptionId;
            state.ForMultiMonthResumeModal.align2monthlyBoundary = action.payload.align2monthlyBoundary;
        },
        setFieldsForCancelPauseModal: (state, action) => {
            state.ForCancelPauseModal.LiveSubscriptionId = action.payload.LiveSubscriptionId;
            state.ForCancelPauseModal.align2monthlyBoundary = action.payload.align2monthlyBoundary;
        },
        setFieldsForMMEditOrderModal: (state, action) => {
            state.ForMMEditOrderModal.orderId = action.payload.orderId;
            state.ForMMEditOrderModal.subscriptionId = action.payload.subscriptionId;
        },
        setFieldsForAddEventCustomFieldsModal: (state, action) => {
            state.ForAddEventCustomFieldsModal.eventId = action.payload.eventId;
        },
        setFieldsForEditEventCustomFieldModal: (state, action) => {
            state.ForEditEventCustomFieldModal.question = action.payload.question;
            state.ForEditEventCustomFieldModal.eventId = action.payload.eventId;
        },
        setFieldsForDeleteEventCustomFieldModal: (state, action) => {
            state.ForDeleteEventCustomFieldModal.questionId = action.payload.questionId;
            state.ForDeleteEventCustomFieldModal.eventId = action.payload.eventId;
        },
        setFieldsForSingleRaiseInvoiceModal: (state, action) => {
            state.ForSingleRaiseInvoiceModal.subscriptionId = action.payload.subscriptionId;
            state.ForSingleRaiseInvoiceModal.liveSubId = action.payload.liveSubId;
        },
        setFieldsForQuickCollectModal: (state, action) => {
            state.ForQuickCollectModal.subscriptionId = action.payload.subscriptionId;
            state.ForQuickCollectModal.liveSubId = action.payload.liveSubId;
        },
        setFieldsForEditorJSModal: (state, action) => {
            state.ForEditorJSModal.content = action.payload.content;
            state.ForEditorJSModal.fieldType = action.payload.fieldType;
            state.ForEditorJSModal.sourceModal = action.payload.sourceModal;
        },
        setFieldsForAddCustomerKYCFieldModal: () => {
            // Empty for now, can be extended if needed
        },
        setFieldsForEditCustomerKYCFieldModal: (state, action) => {
            state.ForEditCustomerKYCFieldModal.question = action.payload.question;
        },
        setFieldsForDeleteCustomerKYCFieldModal: (state, action) => {
            state.ForDeleteCustomerKYCFieldModal.questionId = action.payload.questionId;
        },
        setFieldsForMoveStudentModal: (state, action) => {
            state.ForMoveStudentModal.LiveSubscriptionId = action.payload.LiveSubscriptionId;
            state.ForMoveStudentModal.currentSubscriptionType = action.payload.currentSubscriptionType;
        }
    }
})

export const {
    setBankAccountNumber,
    setIFSCCode,
    setAccountName,
    setFieldsForEditSubscriptionModal,
    setFieldsForQuickAddModal,
    setFieldsForPauseLiveSubscriptionModal,
    setFieldsForMarkOrderPaidModal,
    setFieldsForEditLiveSubscriptionModal,
    setFieldsForTerminateLiveSubscriptionModal,
    setFieldsForOrderSummaryModal,
    setFieldsForRemindPaymentWhatsappModal,
    setFieldsForStatsForOrders,
    updateDataForFetchExistingSubsctibersModal,
    setDataForFetchExistingSubsctibersModal,
    setFieldsForDeleteLiveSubscriptionModal,
    setFieldsForPauseErrorModal,
    setFieldsForResumeLiveSubscriptionModal,
    setFieldsForAddTeamMemberModal,
    setFieldsForRevokeRoleModal,
    setFieldsForEditEventsModal,
    setFieldsForEditOfferModal,
    setFieldsForEventQRCode,
    setFieldsForOfferQRCode,
    setFieldsForQRCodeSource,
    setFieldsForMultiMonthPauseModal,
    setFieldsForMultiMonthResumeModal,
    setFieldsForCancelPauseModal,
    setFieldsForMMEditOrderModal,
    setFieldsForAddEventCustomFieldsModal,
    setFieldsForEditEventCustomFieldModal,
    setFieldsForDeleteEventCustomFieldModal,
    setFieldsForSingleRaiseInvoiceModal,
    setFieldsForQuickCollectModal,
    setFieldsForEditorJSModal,
    setFieldsForAddCustomerKYCFieldModal,
    setFieldsForEditCustomerKYCFieldModal,
    setFieldsForDeleteCustomerKYCFieldModal,
    setFieldsForMoveStudentModal
} = ArbitrarySlice.actions;
export default ArbitrarySlice.reducer;